import React, { useState, useEffect } from 'react'
import { Row, Col, Table, Space, Button, Drawer, notification } from "antd";
import moment from 'moment';
import { DEFAULT_MASTER_DRAWER_WIDTH, SUCCESS_STATUS } from '../../utility/Constants';
import DrawableCloseIcon from '../common/DrawableCloseIcon';
import StudentDueEntry from './StudentDueEntry';
import memberService from '../../api/member.service';

const StudentDueList = ({ dueList }) => {
    console.log("dueList", dueList);

    const [page, setPage] = useState(1);
    const [dueMemberList, setDueMemberList] = useState(dueList);
    console.log("dueMemberList", dueMemberList);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [saveDueList, setSaveDueList] = useState([]);
    console.log("saveDueListPaynow", saveDueList);
    const [selectedDueMember, setSelectedDueMember] = useState(null);

    useEffect(() => {
        setDueMemberList(dueList);
    }, [dueList]);

    const showDrawer = (dueMemberList) => {
        console.log("Original Form Values Paynow:", dueMemberList);
        setOpenDrawer(true);
        setSaveDueList([]);
        setSelectedDueMember(dueMemberList);

        const formattedValues = {
            formdata: {
                payment_id: dueMemberList.payment_id,
                enrollment_id: dueMemberList.enrollment_id,
                receipt_dtl_id: dueMemberList.receipt_dtl_id,
            },
        };
        console.log("Formatted Form Data:", formattedValues);

        memberService.allMemberPayNowDueList(formattedValues)
            .then((res) => {
                const responseData = res.data?.response_data?.response_data;
                console.log("responseData", responseData);
                if (res.data.response_status === SUCCESS_STATUS) {
                    if (responseData && responseData.length > 0) {
                        setSaveDueList(responseData);
                    } else {
                        notification.info({
                            message: 'No Data Found',
                            description: 'No data found for the selected criteria.',
                        });
                    }
                } else {
                    notification.error({
                        message: 'Error',
                        description: res.data.response_data?.response_msg || 'An unknown error occurred.',
                    });
                }
            })
            .catch((error) => {
                console.error("API Error:", error);
                notification.error({
                    message: 'Error',
                    description: 'Failed to fetch data. Please try again later.',
                });
            })
            .finally(() => {
                console.log("first");
            });
    };

    const handleSaveSuccess = () => {
        // Close the drawer
        setOpenDrawer(false);

        // Remove the processed entry from the dueMemberList
        const updatedList = dueMemberList.filter(member => member.payment_id !== selectedDueMember.payment_id);
        setDueMemberList(updatedList);
    };

    const onClose = () => {
        setOpenDrawer(false);
    };

    const pageSize = 10;

    const pagination = {
        current: page,
        pageSize: pageSize,
    };

    const columns = [
        {
            title: '#',
            dataIndex: 'index',
            render: (text, record, index) => (pagination.current - 1) * pagination.pageSize + index + 1,
            width: '5%',
        },
        {
            title: 'Name',
            dataIndex: 'member',
            key: 'member',
            render: (text, record) => `${record.member_fname} ${record.member_lname}`,
        },

        {
            title: 'Programme Name',
            dataIndex: 'programme_name',
            key: 'programme_name',
        },
        {
            title: ' Month',
            dataIndex: 'month_name',
            key: 'month_name',
        },
        {
            title: 'Receipt No',
            dataIndex: 'payment_no',
            key: 'payment_no',
        },
        {
            title: 'Receipt Date',
            dataIndex: 'payment_date',
            key: 'payment_date',
            // render: (text) => text ? moment(text).format('DD-MM-YYYY') : '',
        },

        {
            title: 'Due Amount',
            dataIndex: 'short_excess_amount',
            key: 'short_excess_amount',
        },
        {
            title: 'Action',
            key: 'action',
            render: (selectedObj) => (

                <Space size="middle">

                    <Button
                        htmlType="button"
                        type="ghost"
                        size="small"
                        shape="round"
                        style={{ backgroundColor: 'red', color: 'white', borderColor: 'red' }}
                        onClick={() => showDrawer(selectedObj)}
                    > Pay Now </Button>

                </Space>
            ),
        },
    ];

    return (
        <div>
            <Table
                columns={columns}
                rowKey={(record, index) => index}
                dataSource={dueMemberList}
                pagination={{
                    current: page,
                    pageSize,
                    onChange: (page) => setPage(page),
                }}
                size="small"
            />

            <Drawer
                title="Pay Due Amount"
                width={DEFAULT_MASTER_DRAWER_WIDTH}
                onClose={onClose}
                visible={openDrawer}
                bodyStyle={{
                    paddingBottom: 80,
                }}
                destroyOnClose={true}
                closeIcon={<><DrawableCloseIcon /></>}
            >
                <StudentDueEntry
                    data={saveDueList}
                    onDrawerClose={onClose}
                    onSaveSuccess={handleSaveSuccess}
                />
            </Drawer>
        </div>
    )
}

export default StudentDueList